module.exports = __webpack_public_path__ + "img/img8.088e3bef.png";